<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-parac">This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="linespace"> </p>
<p class="center-parac"><span class="smallcaps">THOMAS DUNNE BOOKS</span>.</p>
<p class="center-parac">An imprint of St. Martin’s Press.</p>
<p class="linespace"> </p>
<p class="center-parac"><span class="smallcaps">RAIDERS FROM THE NORTH</span>. Copyright © 2009 by Alex Rutherford. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="linespace"> </p>
<p class="center-parac"><a href="http://www.thomasdunnebooks.com" target="_blank">www.thomasdunnebooks.com</a></p>
<p class="center-parac"><a href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="linespace"> </p>
<p class="center-parac">Library of Congress Cataloging-in-Publication Data</p>
<p class="para"> </p>
<p class="left-para1">Rutherford, Alex, 1948-</p>
<p class="left-para2">Raiders from the north : empire of the Moghul /Alex</p>
<p class="left-para1">Rutherford.—1st U.S. ed.</p>
<p class="left-para3">p. cm.</p>
<p class="left-para2">    ISBN 978-0-312-59700-9</p>
<p class="copy">1. Farghona (Uzbekistan)—History—Fiction. 2. Babur, Emperor of Hindustan, 1483-1530—Fiction. 3. Mogul Empire—History-Fiction. 4. Mogul Empire—Kings and rulers—Fiction. I.Title.</p>
<p class="left-para1">PR6118.U92R35 2010</p>
<p class="left-para1">823'.92—dc22</p>
<p class="right-para">2010002336</p>
<p class="linespace"> </p>
<p class="center-parac">First published in Great Britain by Headline Review, an imprint of Headline Publishing Group</p>
<p class="linespace"> </p>
<p class="center-parac">First U.S. Edition: May 2010</p>
<p class="linespace"> </p>
<p class="center-parac">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?7a2f8de5